export const TENANT_INACTIVE_EVENT = 'ascend:tenant-inactive';

export type TenantInactiveDetail = {
  message?: string;
};
